import * as styles from './styles.css';
import { FC } from 'react';
import cn from 'clsx';

export interface ILabelProps {
  children: string;
  background: 'red' | 'var(--theme-green)';
}

export const Label: FC<ILabelProps> = ({ children, background }) => {
  return <span className={cn(styles['label'], styles[background])}>{children}</span>;
};
